var _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefactoolRealOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1365 725",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      backgroundColor: "rgb(230, 230, 230)",
      maxWidth: "100%",
      height: "auto",
      display: "block",
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1365,
    height: 725,
    fill: "rgb(230, 230, 230)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 650,
    height: 565,
    rx: 5,
    ry: 5,
    fill: "#282c34",
    stroke: "#4CAF50",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 650,
    height: 30,
    rx: 5,
    ry: 5,
    fill: "#21252b",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 100,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "white"
  }, "Terminal - Execu\xE7\xE3o da Refactool"), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 140
  }, "user@dev:~$ git clone https://github.com/gabrielsalvesdev/refactool"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 170
  }, "Cloning into 'refactool'..."), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 200
  }, "remote: Enumerating objects: 1010, done."), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 230
  }, "Receiving objects: 100% (1010/1010), 271.08 KiB | 3.27 MiB/s, done."), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 260
  }, "Resolving deltas: 100% (477/477), done."), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 290
  }, "user@dev:~$ cd refactool/")), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 320,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, "user@dev:~/refactool$ python microservices/source-provider/src/"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 350,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, "analyze_repo.py https://github.com/gabrielsalvesdev/captool -o"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 380,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#5277ff"
  }, "analyses/captool_analysis.txt --provider gemini"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 410,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, "2025-03-04 07:39:27 [info] Reposit\xF3rio clonado com sucesso"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 440,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, "2025-03-04 07:39:27 [info] Usando Gemini como provedor de IA"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 470,
    fontFamily: "Consolas, monospace",
    fontSize: 16,
    fill: "#abb2bf"
  }, "2025-03-04 07:39:27 [info] Iniciando an\xE1lise do projeto"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 80,
    width: 585,
    height: 565,
    rx: 5,
    ry: 5,
    fill: "white",
    stroke: "#4CAF50",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 730,
    y: 80,
    width: 585,
    height: 30,
    rx: 5,
    ry: 5,
    fill: "#4CAF50",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 102,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "white"
  }, "analyses/captool_analysis.txt - Resultado da An\xE1lise"), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, monospace",
    fill: "#333"
  }, /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 140,
    fontSize: 18,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "# Relat\xF3rio de An\xE1lise do Projeto"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 175,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "## Vis\xE3o Geral"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 200,
    fontSize: 15
  }, "- Total de arquivos: 10"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 225,
    fontSize: 15
  }, "- Total de linhas de c\xF3digo: 426"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 250,
    fontSize: 15
  }, "- Total de fun\xE7\xF5es: 15"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 275,
    fontSize: 15
  }, "- Total de classes: 2"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 310,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "## Linguagens Utilizadas"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 335,
    fontSize: 15
  }, "- Python: 3 arquivo(s)"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 360,
    fontSize: 15
  }, "- Unknown: 7 arquivo(s)"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 395,
    fontSize: 16,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "## An\xE1lises de Arquivos"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 420,
    fontSize: 15,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "### teste_prob_comum.py"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 445,
    fontSize: 15
  }, "- Linhas totais: 39"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 470,
    fontSize: 15
  }, "- Linhas em branco: 0"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 495,
    fontSize: 15
  }, "- Linhas de c\xF3digo: 39"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 520,
    fontSize: 15
  }, "- Complexidade: 2.0"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 550,
    fontSize: 15,
    fontWeight: "bold",
    fill: "#4CAF50"
  }, "#### Sugest\xF5es de Melhoria"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 575,
    fontSize: 15,
    fill: "#555"
  }, "- Linha 24: Melhora a clareza e a precis\xE3o da mensagem."), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 600,
    fontFamily: "Consolas, monospace",
    fontSize: 11,
    fill: "#996633"
  }, "Original: logger.warning(\"A placa Wi-Fi n\xE3o est\xE1 no modo de monitoramento...\")"), /*#__PURE__*/React.createElement("text", {
    x: 750,
    y: 625,
    fontFamily: "Consolas, monospace",
    fontSize: 11,
    fill: "#4CAF50"
  }, "Sugest\xE3o: logger.warning(\"A interface Wi-Fi n\xE3o est\xE1 em modo de monitoramento...\")")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefactoolRealOutput);
export default __webpack_public_path__ + "static/media/refactool-real-output.f6ebf02dfed990f9454520bb750db464.svg";
export { ForwardRef as ReactComponent };